import * as PropTypes from 'prop-types';

import {STATUS, Status} from 'constants/StatusConstants';

export const COMPUTED_STATE_SHAPE = PropTypes.shape({
  errorMessage: PropTypes.string,
  status: PropTypes.oneOf(Object.values(STATUS)).isRequired,
});

interface FailedComputedState {
  status: Status.FAILED;
  errorMessage: string;
}

export type ComputedState =
  | {
      status: Status.PENDING | Status.RUNNING | Status.SUCCEEDED;
      errorMessage: null;
    }
  | FailedComputedState;
